import { CheckIcon } from '@heroicons/react/solid';
import { useMultiSelectWithProvider } from 'use-multiselect';

const GalleryItem = ({ file, selected, onSelect }) => {
	return (
		<li className="relative">
			<div className="group block w-full aspect-w-10 aspect-h-7 rounded-lg border border-gray-100 bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-blue-500 overflow-hidden">
				<img
					src={file.imageUrl}
					alt={file.title}
					className="object-cover pointer-events-none group-hover:opacity-75"
				/>
				{selected && (
					<CheckIcon className="h-5 w-5 bg-blue-500 text-white rounded absolute left-2 top-2" />
				)}
				<button
					type="button"
					className="absolute inset-0 focus:outline-none"
					onClick={() => onSelect(file, !selected)}
				>
					<span className="sr-only">View details for {file.title}</span>
				</button>
			</div>
		</li>
	);
};
const Gallery = ({ schema = {} }) => {
	const { files } = schema;
	const { isSelected, setSelected, deSelectAll, isMultiSelectActive } =
		useMultiSelectWithProvider();
	const selectItem = (item, selection) => {
		if (isMultiSelectActive) deSelectAll();
		setSelected(item, selection);
	};
	return (
		<>
			<ul className="grid grid-cols-2 gap-4 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 my-4">
				{files.map((file) => (
					<GalleryItem
						key={file.id}
						file={file}
						onSelect={selectItem}
						selected={isSelected(file)}
					/>
				))}
			</ul>
		</>
	);
};

export default Gallery;
